import React from "react";
import "./NoDataFallback.scss";
import NoDataSvg from "./NoDataSvg";

type ComponentProps = {
  testId: string;
  noDataText: string;
  message: string;
  hasBorder?: boolean;
  maxHeight: string;
}

const NoDataFallback: React.FC<ComponentProps> = ({
  testId,
  noDataText,
  message,
  hasBorder = true,
  maxHeight = '15vh'
}) => {
  return (
    <div
      className="full-page-container"
      style={{
        border: hasBorder ? "1px groove" : "none",
      }}
    >
      <div className="centered-content">
        <NoDataSvg />
        <div>
          <p
            className="evrCaptionText evrBold"
            data-testid={`${testId}-no-data`}
          >
            {noDataText}
          </p>
          <p className="evrCaptionText" data-testid={`${testId}-message`}>
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoDataFallback;
